import React, { useEffect, useState, useRef } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import useWindowSize from '../../../hooks/useWindowSize';

import { isEmpty, keys, pickBy } from 'lodash';
import { bob, k2aCore } from '../../../data/tabs';

import queryString from 'query-string';

import { array } from 'prop-types';

import { Grid, GridNoRecords, GridColumn as Column } from '@progress/kendo-react-grid';
import { process as kendoProcess } from '@progress/kendo-data-query';
import BobLoadingMask from '../../../components/BobLoadingMask';
import BobModal from '../../../components/BobModal';
import CreateSiteModal from '../SitePage/CreateSiteModal';
import DeleteSiteModal from '../SitePage/DeleteSiteModal';
import BobTableContextMenu from '../../../components/BobTableContextMenu';
import CreateSubscriptionModal from '../Modals/CreateSubscriptionModal';
import PreviewWeatherDataModal from '../Modals/PreviewWeatherDataModal';

import { dashboardContent } from '../../../localization/en-us/dashboardContent';
import {calculateMinColumnWidths} from '../../../helpers/calculateMinColumnWidths';

import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';
import classes from './Table.module.css';

const initialDataState = {
    sort: [],
    take: 10,
    skip: 0
};

const SitesTable = ({
    activeTab,
    activeNavClient,
    activeNavCompany,
    activeNavSite,
    bobLoading,
    clientSites,
    clientSitesMeta,
    createSiteModalOpen,
    companies,
    dashboardEndTimeStamp,
    dashboardIsCurrentTimeStamp,
    dashboardStartTimeStamp,
    deleteSiteModalOpen,
    fetchDashboardData,
    fetchNavClients,
    fetchNavSites,
    fetchSingleSite,
    history,
    handleToggleCreateSiteModal,
    handleToggleDeleteSiteModal,
    handleToggleSubscribeToSiteAlertsModal,
    resetNavOptions,
    refreshTab,
    setRefreshTab,
    setNavClient,
    setNavCompany,
    setNavSite,
    setTableProps,
    siteFilters,
    searchTerm,
    subscribeToAlertsSiteModalOpen,
    targetNavCompany,
    totalsData,
    workbookModeEnabled,
    ...props
}) => {
    const [sortFilter] = useState('');
    const [typeFilters, setTypeFilters] = useState([]);
    const [priorityFilters, setPriorityFilters] = useState([]);
    const [skip, setSkip] = useState(0);
    const [take, setTake] = useState(10);
    const [pageable] = useState({ pageSizes: true });
    const [site, setSite] = useState(null);
    const [dataState, setDataState] = useState(initialDataState);
    const [siteColumnWidth, setSiteColumnWidth] = useState(250);
    const [previewWeatherDataModalOpen, setPreviewWeatherDataModalOpen] = useState(false);

    const queryValues = queryString.parse(history.location.search);
    const companyId = queryValues.company;
    const clientId = queryValues.client;

    const isInitialMount = useRef(true);
    const gridDivRef = useRef(null);
    const gridRef = useRef(null);

    const windowSize = useWindowSize();

    useEffect(() => {
        const columns = columnList.map((c) => {
            c.width = c.field === 'siteName' ? 250 : c.width;
            if (c.field.toLowerCase().includes('faultcount')) {
                c.show = dashboardIsCurrentTimeStamp;
            }
            else {
                c.show = true;
            }
            return c;
        });

        const colWidth = calculateMinColumnWidths(columns.filter(c => c.show), gridDivRef.current.offsetWidth, 'siteName', 250, true);
        setSiteColumnWidth(colWidth);
        columns.find(c => c.id === 'siteColumn').width = colWidth;
        setColumnList(columns);

    }, [windowSize, dashboardIsCurrentTimeStamp]);


    useEffect(() => {
        if (!workbookModeEnabled) {
            initialDataState.take = take;
            setDataState(initialDataState);
        }
        setColumnList(columnList.map(c => {
            c.filterable = c.actionCell ? false : workbookModeEnabled;
            return c;
        }));    
    }, [workbookModeEnabled]);

    useEffect(() => {
        setSkip(0);
        setTake(10);
        fetchNavClients(companyId);
    }, [clientId]);

    useEffect(() => {
        if (siteFilters.type || Object.values(siteFilters.priority).includes(true)) {
            const typeFilters = siteFilters.type.map(filter => filter.id);
            const priorityFilters = keys(pickBy(siteFilters.priority));

            setTypeFilters(typeFilters);
            setPriorityFilters(priorityFilters);
        }
    }, []);

    useEffect(() => {
        if (activeNavClient && activeNavClient.id && isEmpty(clientSites)) {
            initializeFetch();
        }
    }, [activeNavClient]);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            if (siteFilters.type || Object.values(siteFilters.priority).includes(true)) {
                if (!isEmpty(activeNavClient) && !isEmpty(clientSitesMeta)) {
                    initializeFetch();
                }
            } else {
                const init = async () => {
                    initializeFetch();
                };
                
                if (activeNavClient.id && !isEmpty(clientSites)) init();
            }
        }
    }, [siteFilters, dashboardStartTimeStamp, dashboardEndTimeStamp, searchTerm]);

    useEffect(() => {
        const refresh = async () => {
            let page = 1;

            if ( skip && take ) {
                page = skip / take + 1;
            }

            if (sortFilter) {
                await fetchDashboardData(activeNavCompany.id, 'ClientSite', { clientId: activeNavClient.id, sort: sortFilter, searchFilter: searchTerm, page: page, limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp  }, typeFilters, priorityFilters);
            } else {
                await fetchDashboardData(activeNavCompany.id, 'ClientSite', { clientId: activeNavClient.id, sort: 'default^desc', searchFilter: searchTerm, page: page, limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
            }

            setRefreshTab();
        };

        if (refreshTab) refresh();
    }, [refreshTab]);

    const initializeFetch = async () => {
        setSkip(0);
        const typeFilters = siteFilters.type.map(filter => filter.id);
        const priorityFilters = keys(pickBy(siteFilters.priority));

        setTypeFilters(typeFilters);
        setPriorityFilters(priorityFilters);

        if (!isEmpty(searchTerm)) {
            setTableProps({
                search: searchTerm,
                sort:   sortFilter
            });
        }

        if (sortFilter) {
            await fetchDashboardData(activeNavCompany.id, 'ClientSite', { clientId: activeNavClient.id, sort: sortFilter, limit: take, searchFilter: searchTerm, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
        } else {
            await fetchDashboardData(activeNavCompany.id, 'ClientSite', { clientId: activeNavClient.id, sort: 'default^desc', limit: take, searchFilter: searchTerm, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
        }
    };

    const fetchSiteListAfterCreate = async (body, type) => {
        handleToggleCreateSiteModal(false);

        // If you create a site, refresh the nav client
        if (type === 'create') {
            await setNavClient({
                name: body.clientName,
                id:   body.clientId
            });
        }

        // Refresh the list of nav sites
        fetchNavSites(body.clientId);

        // Set the newly created site as the selected nav site
        if (type === 'create') {
            setNavSite({
                name: body.name,
                id:   body.id
            });
        }

        setSkip(0);

        // If you updated site, refetch the client site table.
        if (type === 'update') {
            await fetchDashboardData(activeNavCompany.id, 'ClientSite', { clientId: activeNavClient.id, sort: 'default^desc', searchFilter: '', limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
        }
    };

    const fetchSites = async searchTerm => {
        setSkip(0);

        await fetchDashboardData(activeNavCompany.id, 'ClientSite', { clientId: activeNavClient.id, sort: 'default^desc', searchFilter: searchTerm, limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
    };

    const subscribeSiteData = (siteData) => {
        siteData.name = siteData.siteName;
        siteData.id = siteData.siteId;

        setSite(siteData);
        handleToggleSubscribeToSiteAlertsModal(true);
    };

    const renderNavUrl = dataItem => {
        const queryValues = queryString.parse(history.location.search);

        return `site?client=${dataItem.clientId}&company=${queryValues.company}&site=${dataItem.siteId}`;
    };

    const handleNav = async dataItem => {
        let path = '/v2/dashboard/site';

        const queryValues = queryString.parse(history.location.search);
        queryValues.client = dataItem.clientId;
        queryValues.site = dataItem.siteId;

        if (targetNavCompany.id !== dataItem.companyId) {
            resetNavOptions('all');
            const company = companies.find(item => item.company.id === dataItem.companyId);
            setNavCompany({
                name: company.company.name,
                id:   company.company.id
            });
            fetchNavClients(dataItem.companyId);
        } else {
            resetNavOptions('site');
        }

        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${path}?${queryValuesString}`);

        await fetchSingleSite(queryValues);
    };

    const nameCell = props => {
        return (
            <td>
                <Link
                    to={renderNavUrl(props.dataItem)}
                    onClick={
                        (e) => {
                            if (!e.ctrlKey) {
                                handleNav(props.dataItem);
                            }
                        }
                    }
                >
                    {props.dataItem[props.field]}
                </Link>
            </td>
        );
    };

    const priorityCell = props => {
        let imgPath = '/assets/images/low.svg';
        if (props.field === 'mediumFaultCount') {
            imgPath = '/assets/images/medium.svg';
        } else if (props.field === 'highFaultCount') {
            imgPath = '/assets/images/high.svg';
        }
        return (
            <td>
                <img className={ props.dataItem[props.field] > 0 ? classes.IconImage: classes.IconImageGray} src={imgPath} alt="" />
                {props.dataItem[props.field]}
            </td>
        );
    };

    const scoresCell = props => {
        let value = props.dataItem[props.field];
        value = value.toString().includes('.') ? parseFloat(value).toFixed(2) : value;
        return (
            <td>
                {value + '%'}
            </td>
        );
    };

    const fetchSiteDataForDelete = (siteData) => {
        setSite(siteData);
        handleToggleDeleteSiteModal(true);
    };

    const handleEditSite = siteData => {
        setSite(siteData);
        process.env.k2aCoreEnabled ?
            history.push({
                pathname: `/v2/dashboard/core/entities/manage`,
                search:   `appId=${k2aCore.key}&childId=e979b520-3695-422d-a914-ba55c51fb316&client=${activeNavClient.id}&company=${activeNavCompany.id}&entityId=${siteData.siteId}&entityParent=${siteData.clientId}&entityType=site&parentId=3ee59a8f-d13a-475b-b424-ee55eef98a65`,
                state:    { 'returnUrl': `/v2/dashboard/client?appId=${bob.key}&childId=f6ba2344-ba47-42c5-a98b-978365ca3936&client=${activeNavClient.id}&company=${activeNavCompany.id}&parentId=a73c8c70-35aa-48b7-a797-4c607ae25280` }
            })
            :
            handleToggleCreateSiteModal(true);
    };

    const handlePreviewWeatherData = siteData => {
        setSite(siteData);
        setPreviewWeatherDataModalOpen(true);
    };

    const actionsCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <BobTableContextMenu
                    type="site"
                    entityData={props.dataItem}
                    onSubscribeAlerts={(entityData) => { subscribeSiteData(entityData); }}
                    onDelete={(entityData) => { fetchSiteDataForDelete(entityData); }}
                    onFetch={(entityData) => handleEditSite(entityData)}
                    onPreviewWeatherData={(entityData) => handlePreviewWeatherData(entityData)}
                />
            </td>
        );
    };


    const onDataStateChange = e => {
        setTake(e.dataState.take);
        setDataState(e.dataState);
    };

    const actionFilterCell = props => {
        return (
            <div />
        );
    };

    const defaultColumnList = [
        {
            title:       dashboardContent.site,
            field:       'siteName',
            id:          'siteColumn',
            cell:        nameCell,
            width:       350,
            show:        true,
            filter:      'text',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: false
        },
        {
            title:       dashboardContent.client,
            field:       'clientName',
            width:       225,
            show:        true,
            filter:      'text',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.buildingType,
            field:       'buildingTypeName',
            width:       200,
            show:        true,
            filter:      'text',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.location,
            field:       'siteLocation',
            width:       200,
            show:        true,
            filter:      'text',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.campus,
            field:       'campusName',
            width:       150,
            show:        true,
            filter:      'text',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.equipment,
            field:       'equipmentCount',
            width:       175,
            show:        true,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.score,
            field:       'siteScore',
            cell:        scoresCell,
            width:       175,
            show:        true,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.faults,
            field:       'totalFaultCount',
            width:       175,
            show:        true,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.high,
            field:       'highFaultCount',
            cell:        priorityCell,
            width:       175,
            show:        true,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.medium,
            field:       'mediumFaultCount',
            cell:        priorityCell,
            width:       175,
            show:        true,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.low,
            field:       'lowFaultCount',
            cell:        priorityCell,
            width:       175,
            show:        true,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       '',
            field:       '',
            cell:        actionsCell,
            locked:      true,
            sortable:    false,
            filterable:  false,
            filterCell:  actionFilterCell,
            width:       75,
            show:        true,
            actionCell:  true,
            reorderable: false
        }
    ];
    const [columnList, setColumnList] = useState(defaultColumnList);

    return (
        <React.Fragment>
            <div ref={gridDivRef} className={classes.Table}>
                <style>
                    { kendoGridInlineStyling }
                </style>
                <Grid
                    ref={gridRef} 
                    sortable={{
                        mode: 'multiple'
                    }}
                    className={classes.KendoGrid}
                    data={kendoProcess(clientSites, dataState)}
                    {...dataState}
                    pageable={pageable}
                    onDataStateChange={onDataStateChange}
                    reorderable={true}
                    filterable={workbookModeEnabled}
                    fixedScroll={true}
                >
                    {
                        bobLoading.includes('ClientSite') || isEmpty(clientSitesMeta) ?
                            <GridNoRecords>
                                Loading sites
                            </GridNoRecords>
                            :
                            null
                    }
                    {
                        columnList.map(
                            (column, index) => 
                                column.show && (
                                    <Column
                                        key={index}
                                        field={column.field}
                                        title={column.title}
                                        id={column.id}
                                        cell={column.cell}
                                        width={column.id === 'siteColumn' ? siteColumnWidth : column.width}
                                        filter={column.filter}
                                        filterCell={column.filterCell}
                                        sortable={column.sortable}
                                        filterable={column.filterable}
                                        locked={column.locked}
                                        reorderable={column.reorderable}
                                    />
                                )
                        )
                    }
                </Grid>
                {
                    subscribeToAlertsSiteModalOpen ?
                        <CreateSubscriptionModal
                            parent={site}
                            parentLabel="Site"
                            handleToggleSubscribeToAlertsModal={handleToggleSubscribeToSiteAlertsModal}
                        />
                        :
                        null
                }
                {
                    createSiteModalOpen ?
                        <BobModal
                            title={site ? 'Edit Site' : 'Add New Site'}
                            hidebuttons={true}
                            isRemoveFooter={true}
                            onClose={() => {
                                setSite(null);
                                handleToggleCreateSiteModal(false);}}
                        >
                            <CreateSiteModal
                                site={site}
                                isEdit={site ? true : false}
                                fetchSiteListAfterCreate={(body, type) => fetchSiteListAfterCreate(body, type)}
                                onClose={() => {
                                    setSite(null);
                                    handleToggleCreateSiteModal(false);}}
                            />
                        </BobModal> : ''
                }
                {
                    deleteSiteModalOpen ?
                        <BobModal
                            title={'Delete Entity'}
                            hidebuttons={true}
                            isRemoveFooter={true}
                            onClose={() => {
                                handleToggleDeleteSiteModal(false);
                            }}
                        >
                            <DeleteSiteModal
                                site={site}
                                fetchSites={fetchSites}
                                onClose={() => { handleToggleDeleteSiteModal(false); }}
                            />
                        </BobModal> : ''
                }
                {
                    previewWeatherDataModalOpen ?
                        <PreviewWeatherDataModal
                            site={{name: site.siteName, id: site.siteId}}
                            onClose={() => setPreviewWeatherDataModalOpen(false)}
                        />
                        :
                        null
                }
                {
                    bobLoading.includes('ClientSite') || isEmpty(clientSitesMeta) ?
                        <BobLoadingMask />
                        :
                        null
                }
            </div>
        </React.Fragment>
    );
};

SitesTable.defaultProps = {
    clientSites: []
};

SitesTable.propTypes = {
    clientSites: array
};

const mapStateToProps = state => ({
    activeNavClient:             state.bob.activeNavClient,
    activeNavCompany:            state.bob.activeNavCompany,
    activeNavSite:               state.bob.activeNavSite,
    bobLoading:                  state.bob.bobLoading,
    companies:                   state.core.companies,
    clientSites:                 state.dashboard.clientSites,
    clientSitesMeta:             state.dashboard.clientSitesMeta,
    clientTabIndex:              state.dashboard.clientTabIndex,
    dashboardEndTimeStamp:       state.dashboard.dashboardEndTimeStamp ? state.dashboard.dashboardEndTimeStamp.format() : null,
    dashboardIsCurrentTimeStamp: state.dashboard.dashboardIsCurrentTimeStamp,
    dashboardStartTimeStamp:     state.dashboard.dashboardStartTimeStamp ? state.dashboard.dashboardStartTimeStamp.format() : null,
    siteFilters:                 state.dashboard.siteFilters,
    targetNavCompany:            state.bob.targetNavCompany
});

const mapDispatchToProps = ({
    ...BobActions,
    ...DashboardActions
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SitesTable));
